import { v4 as uuid } from "uuid";
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const initialState = {
  message: ""  ,
  key: "",
};

const notificationSlice = createSlice({
  name: 'Notification',
  initialState,
  reducers: {
      show: (state, action) => {
      },
      
    addNotification: ((state, action: PayloadAction<{
      content: string
    }>) => {
        state.message = action.payload["data"];
        state.key = state.key = uuid().slice(0, 8);;
      return;
    })
  }
});

 
export const notificationActions = notificationSlice.actions;
export default notificationSlice.reducer;
